import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2 } from '@coursera/cds-core';

import type { TermStatus } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/lib/academicTermTypes';
import { joinMetadataStrings } from 'bundles/program-loggedin-shared/components/Metadata';

import _t from 'i18n!nls/degree-home';

type CreditsInfoProps = {
  termStatus: TermStatus;
  creditsEarned: number;
  creditsInProgress: number;
  creditsPlanned: number;
};

interface Credits {
  creditsEarned?: number;
  creditsInProgress?: number;
  creditsPlanned?: number;
}

const renderCredits = (credits: Credits, message: string) => (
  <Typography2 component="p" variant="bodyPrimary" color="supportText">
    <FormattedMessage message={message} {...credits} />
  </Typography2>
);

const CreditsInfo: React.VFC<CreditsInfoProps> = ({ termStatus, creditsEarned, creditsInProgress, creditsPlanned }) => {
  let message = '';
  const parts = [];

  switch (termStatus) {
    case 'COMPLETE':
    case 'IN_PROGRESS':
      if (creditsEarned) {
        parts.push(_t('{creditsEarned} {creditsEarned, plural, =1 {credit} other {credits}} earned'));
      }
      if (creditsInProgress) {
        parts.push(_t('{creditsInProgress} {creditsInProgress, plural, =1 {credit} other {credits}} in-progress'));
      }
      if (creditsPlanned) {
        parts.push(_t('{creditsPlanned} {creditsPlanned, plural, =1 {credit} other {credits}} planned'));
      }
      message = joinMetadataStrings(parts);
      break;
    case 'NOT_STARTED':
      if (creditsPlanned) {
        message = _t('{creditsPlanned} {creditsPlanned, plural, =1 {credit} other {credits}} planned');
      } else {
        message = _t('0 credits');
      }
      break;
    default:
      message = _t('0 credits');
  }
  return renderCredits({ creditsEarned, creditsInProgress, creditsPlanned }, message);
};

export default CreditsInfo;
